<template>
  <div class="works-detail" v-show="isShow">
    <div class="left-right-content clearfix">
      <div class="c-left">
        <div class="article-top-info">
          <div class="art-top-title">{{ production.productionName }}</div>
          <div class="type-tags">
            <span class="type">{{ production.tagStr }}</span>
            <span
              class="tag"
              v-for="(item, index) in production.tags"
              :key="index"
              >{{ item.tag }}</span
            >
          </div>
          <div class="zc-count clearfix">
            <i class="icon see"></i
            ><span class="much">{{ production.viewCount }}</span>
            <i class="icon pinglun"></i
            ><span class="much">{{ production.commentCount }}</span>
            <i class="icon fenxiang"></i
            ><span class="much">{{ production.shareCount }}</span>
            <!-- <span class="much"><i class="el-icon-more"></i></span> -->
            <span class="tips" v-if="production.isOriginal == 1"
              ><i class="el-icon-warning"></i> 未经作者授权，禁止转载</span
            >
            <span class="date">{{ production.createTime | formatTime }}</span>
          </div>
        </div>
        <div class="article-center-cont">
          <div v-html="production.productionInrto"></div>
          <div v-if="production.productionForm == 1">
            <img
              v-for="(item, index) in picList"
              :key="index"
              :src="item.url"
              alt=""
            />
          </div>
          <div v-else-if="production.videoSource == 1">
            <div class="demand-play" v-if="production.productionVideo && ccsrc != '1'">
              <cc-video
                :ccsrc="ccsrc"
                :ccPic="ccPic"
                v-if="production.videos.status == 1"
              ></cc-video>
              <div
                class="no-success-add"
                v-if="
                  production.videos.status == 0 || production.videos.status == 2
                "
              >
                <img class="img-fm" :src="production.productionCover" alt="" />
                <i
                  class="no-play-icon"
                  @click="notStatus(production.videos.status)"
                ></i>
              </div>
            </div>
          </div>

          <div v-else v-html="production.videoCode" class="iframe-h"></div>
        </div>

        <div class="articled-zan-cai">
          <div class="item" :class="{ active: production.likeFlag }">
            <i class="icon zan"></i>
            <span>{{ production.likeCount }}</span>
          </div>
          <div class="item" :class="{ active: production.disLikeFlag }">
            <i class="icon cai"></i>
            <span>{{ production.dislikeCount }}</span>
          </div>
        </div>

        <div
          class="pro-work-item clearfix"
          style="border-top: 5px solid #f6f6f6;"
        >
          <div class="item-infoes same-left">
            <talkPart
              :objType="1"
              :objId="objId"
              v-if="isReload"
              :loadShow="false"
              :isProView="true"
              :isShowCreateTime="false"
            ></talkPart>
          </div>
        </div>

        <div class="about-works" v-if="aboutTotal >0">相关作品</div>

        <div
          class="pro-work-item clearfix"
          v-for="(item, index) in abortProductionList"
          :key="index"
        >
          <div class="user-avatar">
            <router-link
              :to="{ path: '/home', query: { userId: item.creatorId } }"
              class="avatar-f"
            >
              <img :src="item.imgUrl" alt="" />
            </router-link>
            <!--            <div class="tip-title">推荐</div>-->
          </div>
          <div class="item-infoes">
            <!-- username 和 称号 -->
            <div class="user-name-title clearfix">
              <router-link
                :to="{ path: '/home', query: { userId: item.creatorId } }"
                class="name"
                >{{ item.creatorName }}</router-link
              >
              <div
                class="new-tchh clearfix"
                v-if="item.userRankName != '' && item.userRankName != null"
              >
                <i
                  class="icon zs"
                  v-if="item.userRankName.split(',')[1] == '资深作者'"
                ></i>
                <i
                  class="icon yx"
                  v-if="item.userRankName.split(',')[1] == '优秀作者'"
                ></i>
                <i
                  class="icon hy"
                  v-if="item.userRankName.split(',')[1] == '活跃作者'"
                ></i>
                <span class="zuoz">{{ item.userRankName.split(",")[1] }}</span>
                <span class="shu">|</span>
                <span class="liny">{{ item.userRankName.split(",")[0] }}</span>
              </div>
            </div>
            <!-- 文字 -->
            <div class="user-words">
              <router-link
                :to="{ path: '/worksdetail', query: { id: item.id,plate:item.belongSection } }"
                target="_blank"
              >
                <div v-html="item.productionInrto"></div>
              </router-link>
            </div>
            <div class="images-list clearfix" v-if="item.productionForm == 1">
              <div
                v-for="(item_bak, index_bak) in item.picList"
                :key="index_bak"
              >
                <router-link
                  :to="{ path: $route.fullPath }"
                  @click.native="toLogWithNextPage(item.id,item.belongSection)"
                  class="img-grid"
                  v-if="index_bak < 9"
                  :style="{ 'background-image': 'url(' + item_bak.uri + ')' }"
                ></router-link>
              </div>
            </div>
            <!-- video -->
            <div class="o-video" v-else>
              <router-link
                :to="{ path: $route.fullPath }"
                @click.native="toLogWithNextPage(item.id,item.belongSection)"
              >
                <img :src="item.productionCover" alt="" />
                <div class="mask">
                  <i class="el-icon-video-play"></i>
                </div>
              </router-link>
            </div>
            <!-- 类型 关注 标签 -->
            <div class="type-tags">
              <!--<router-link
                :to="{
                  path: '/productionList',
                  query: {plate: item.belongSection }
                }"
                target="_blank"
              >
                <span class="type">{{ item.tagStr }}</span>
              </router-link>-->
              <span class="type">{{ item.tagStr }}</span>
              <span
                class="tag-item"
                v-for="(item_bak, index_bak) in item.tags"
                :key="index_bak"
                >{{ item_bak.tag }}</span
              >
            </div>
          </div>
        </div>
        <div class="pagintion-f">
          <el-pagination
            background
            @current-change="about"
            layout="prev, pager, next"
            :current-page="abortProductionParam.pageIndex"
            :page-size="abortProductionParam.pageSize"
            :total="aboutTotal"
            :hide-on-single-page="true"
          >
          </el-pagination>
        </div>

        <!--<pagination align="center" v-show="aboutTotal>0" :total="aboutTotal" :page.sync="abortProductionParam.pageIndex" :limit.sync="abortProductionParam.pageSize"-->
        <!--:pageSizes="abortProductionParam.pageSizes"       @pagination="about"/>-->
      </div>
      <div class="c-right">
        <div class="one-item">
          <div class="detail-userinfo">
            <router-link
              :to="{ path: '/home', query: { userId: userInfo.userId } }"
              class="avatar-f"
              ><img :src="userInfo.imgUrl" alt=""
            /></router-link>
            <div class="user-name">
              <router-link
                :to="{ path: '/home', query: { userId: userInfo.userId } }"
                >{{ userInfo.userName }}</router-link
              >
            </div>
            <div class="chenghao">{{ userInfo.signature }}</div>
            <div class="qianming">{{ userInfo.introduction }}</div>
            <div class="btns" v-if="isLogin && userInfo.userId != loginUserId">
              <el-button
                class="btn wgz-btn"
                v-if="userInfo.followStatus == 0"
                @click="doFollow(userInfo.userId)"
                ><i class="el-icon-plus"></i> 关注</el-button
              >
              <el-button
                class="btn"
                v-else-if="userInfo.followStatus == 1"
                @click="undoFollower(userInfo.userId)"
                >已关注</el-button
              >
              <el-button
                class="btn"
                v-else-if="userInfo.followStatus == 2"
                @click="undoFollower(userInfo.userId)"
                >互相关注</el-button
              >
              <el-button
                class="btn wgz-btn"
                v-if="friendStatus == 4"
                @click="addFriend()"
                ><i class="el-icon-plus"></i> 加好友</el-button
              >
              <!--<el-button
                class="btn"
                @click="toChart(userInfo.userId)"
                v-else-if="friendStatus == 2"
                >发消息</el-button
              >-->
              <el-button
                class="btn"
                v-else-if="friendStatus == 1"
                style="cursor:auto"
                >请求中</el-button
              >
            </div>
            <ul class="much-list clearfix">
              <li>
                <span class="tit">作品</span>
                <span class="count">{{ userInfo.productionsCount }}</span>
              </li>
              <li>
                <span class="tit">文章</span>
                <span class="count">{{ userInfo.archivesCount }}</span>
              </li>
              <li>
                <span class="tit">粉丝</span>
                <span class="count">{{ userInfo.followersCount }}</span>
              </li>
              <li>
                <span class="tit">关注</span>
                <span class="count">{{ userInfo.followingsCount }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="one-item">
          <div class="one-title">
            其他作品
            <i class="el-icon-refresh-right shuaxin" @click="other"></i>
          </div>
          <div class="works-list">
            <router-link
              :to="{ path: '/worksdetail', query: { id: item.id,plate:item.belongSection } }"
              target="_blank"
              :title="item.productionName"
              class="item"
              v-for="(item, index) in otherProductionList"
              :key="index"
            >
              <div class="work-img-f">
                <img :src="item.productionCover" alt="" />
              </div>
              <div class="work-title">{{ item.productionName }}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import productionApi from '@/api/production'
import axios from 'axios';
import vue from 'vue';
import CcVideo from '@@/pub/ccvideo/ccvideo'
//import tagApi from '@/api/tags'
vue.prototype.$axios = axios;
import userInfoApi from '@/api/userInfo'
import talkPart from '@@/pub/talkpart/talkpart'
import homeApi from '@/api/home'
import apiService from '@/api/index'
//import Pagination from '@/components/Pagination'



export default {
    components: {
        CcVideo,talkPart//,Pagination
    },
    data () {
        return {
            friendStatus:-1,
            otherTotal:0,
            aboutTotal:0,
            isShow:false,
            isLogin: false,
            loginUserId:0,
            objId:0,
            isReload:true,
            videoUrl:"",
            ccsrc: "1",
            ccPic:"",
            textCon: '',
            activitiesAnd: false,
            userInfo:{},
            tagParam:{
                deleteFlag: 0,
            },
            production:{
                id:0,
                productionName:'',
                tagStr:'',
                tags:[],
                viewCount:0,
                commentCount:0,//评论数量
                likeCount:0,//点赞数量
                dislikeCount:0,//踩数量
                shareCount:0,//分享数量
                productionInrto:'',//作品简介
                productionForm: '', //1为图片；2为视频；
                productionCover: '',//作品封面
                productionImage: '',//作品图片
                productionVideo: '',//作品视频
                videoSource:"1", //1为本地；2为第三方；
                videoCode:"",//第三方通用代码
                picList:[],
            },
            productionParam:{
                deleteFlag: 0,
                publishStatus:1,
                pageIndex: 1,
                pageSize: 12,
            },
            otherproductionParam:{
                creatorId:0,
                id:0,
                pageIndex: 1,
                pageSize: 5,
                productionType:0,
                publishStatus:1,
                getType:'other',
                orderType:'hotNum',
            },
            otherProductionList:[],
            abortProductionParam:{
                creatorId:0,
                id:0,
                pageIndex: 1,
                pageSize: 5,
                pageSizes:[5,10,20],
                productionType:0,
                publishStatus:1,
                getType:'about',
                orderType:'hotNum',
            },
            abortProductionList:[],
        }
    },
    beforeMount(){
        let id = this.$route.query.id
        if(id){
            this.objId =parseInt(id)
        }

    },
    mounted() {
        // if(!this.global.isLogin){
        //     this.$message.error("未登录")
        //     return
        // }
        this.initData()
    },
    methods:{
        initData(){

            let this_ = this
            window.ccH5PlayerJsLoaded = true;

            if(this.global.isLogin){
                this_.loginUserId = this.global.userModel.id
                this_.isLogin = true
            }
            //编辑传入ID
            let id = this_.$route.query.id
            this_.production.id =id
            //let id = this_.$route.params.id
            if(id && parseInt(id) !== 0){
                productionApi.select(id).then(rePro => {
                    if(rePro.code == -1 || rePro.response.deleteFlag==1){
                        // let routeData = this.$router.resolve({
                        //   path:'/error',
                        // })
                        // window.open(routeData.href, '_blank');
                        this.$router.push({
                            path:'/error',
                        })
                    }else{
                      if(rePro.response.productionForm == 3){
                        window.open("/workstoryview?id="+id+'&plate='+rePro.response.belongSection,'_self')
                      }else {
                        productionApi.updateCountNum(id).then(() => {

                        })

                        this_.isShow = true

                        this_.production = rePro.response;
                        if(rePro.response.picList!=null){
                          this_.picList = rePro.response.picList
                        }
                        if(rePro.response.productionForm == 2){
                          if(rePro.response.videoSource==1  && rePro.response.productionVideo){
                            this_.ccsrc=rePro.response.productionVideo;
                          }

                          this_.ccPic=rePro.response.productionCover;
                        }

                        //作者信息
                        userInfoApi.select(this_.production.creatorId).then(reUser => {
                          this_.userInfo = reUser.response
                        })

                        //其他作品
                        this.other()
                        //相关作品
                        this.about()

                        this.getFriendStatus()
                      }
                    }

                })
            }else{
                this.$router.push({
                    path:'/error',
                })
                console.log("ERROR FOR ID")
            }
        },
        doFollow(userId){
            let this_ = this
            homeApi.follower(userId).then(data => {
                // console.log(data)
                const status = data.response.status
                if (status >= 1) {
                    this_.userInfo.followStatus=status
                    this_.$message.success("关注成功")
                } else {
                    this_.$message.error("关注失败")
                }
            })
        },undoFollower(userId) {
            let _this = this;
            homeApi.undoFollower(userId).then(data => {
                // console.log(data)
                const status = data.response.status
                if (status == 1) {
                    _this.userInfo.followStatus=0
                    _this.$message.success("取消成功")
                } else {
                    _this.$message.error("取消失败")
                }
            })
        },
        other(){
            let this_ = this
            this_.otherproductionParam.creatorId =this_.production.creatorId
            this_.otherproductionParam.id = this_.production.id
            this_.otherproductionParam.productionType = this_.production.productionType
            console.log("this_.otherproductionParam.pageIndex===",this_.otherproductionParam.pageIndex)


            productionApi.pageList(this_.otherproductionParam).then(reOther => {
                this_.otherProductionList= reOther.list
                this_.otherTotal= reOther.total
                this_.otherproductionParam.pageIndex = reOther.pageNum

                if(this_.otherproductionParam.pageIndex == Math.ceil(this_.otherTotal/this_.otherproductionParam.pageSize) ){
                    this_.otherproductionParam.pageIndex =1
                }else{
                    this_.otherproductionParam.pageIndex = this_.otherproductionParam.pageIndex+1
                }
            })
        },
        about(){
            let this_ = this
            this_.abortProductionParam.creatorId =this_.production.creatorId
            this_.abortProductionParam.id = this_.production.id
            this_.abortProductionParam.productionType = this_.production.productionType
            productionApi.pageList(this_.abortProductionParam).then(reAbout => {
                this_.abortProductionList= reAbout.list
                this_.aboutTotal= reAbout.total
                this_.abortProductionParam.pageIndex = reAbout.pageNum

                // if(this_.abortProductionParam.pageIndex == Math.ceil(this_.aboutTotal/this_.abortProductionParam.pageSize) ){
                //     this_.abortProductionParam.pageIndex =1
                // }else{
                //     this_.abortProductionParam.pageIndex = this_.abortProductionParam.pageIndex+1
                // }
            })
        },
        likeEvent(id,belongSection){
            console.debug(id);
            var _this =this;
            console.debug(_this.isLogin);
            if(_this.isLogin){
                apiService.dolike({"objectType":1,"objectId":id,"belongSection":belongSection,"time": new Date().getMilliseconds()}).then(data => {
                    console.log(data)
                    //_this.initData();

                    _this.production.likeFlag = !_this.production.likeFlag
                    if(_this.production.likeFlag){
                        _this.production.likeCount += 1
                    }else{
                        _this.production.likeCount -= 1
                    }
                    // 重新渲染组件
                    _this.reloadModel()
                })
            }else{
                // _this.$message({
                //     message: '您尚未登录,请登录后操作',
                //     type: 'error'
                // });
                _this.toLog()
            }

        },
        disLikeEvent(id,belongSection){
            console.debug(id);
            var _this =this;
            if(_this.isLogin) {
                apiService.dislike({"objectType": 1, "objectId": id,"belongSection":belongSection,"time": new Date().getMilliseconds()}).then(data => {
                    //_this.initData();
                    console.log(data)
                    _this.production.disLikeFlag = !_this.production.disLikeFlag
                    if(_this.production.disLikeFlag){
                        _this.production.dislikeCount += 1
                    }else{
                        _this.production.dislikeCount -= 1
                    }
                    // 重新渲染组件
                    _this.reloadModel()
                })
            }else{
                // _this.$message({
                //     message: '您尚未登录,请登录后操作',
                //     type: 'error'
                // });
                _this.toLog()
            }
        },
        reloadModel(){
            let _this = this
            // 移除组件
            _this.isReload = false
            // 在组件移除后，重新渲染组件
            // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
            _this.$nextTick(() => {
                _this.isReload = true
            })
        },
        toLog(){
            this.$router.push({
                path:'/login?callback=' + window.location.href,
            })

        } ,
        //转码没成功提示
        notStatus(status){
            let thiss = this
            if(status == 0 ){
                thiss.$message.error("视频转码中...请耐心等待")
            }else{
                thiss.$message.error("视频转码失败，请重新上传")
            }

        },
        //登录并跳转指定页面
        toLogWithNextPage(id,belongSection){

            let url = "/worksdetail?id="+id+"&plate="+belongSection
            let url2 = '/login?callback=' + "http://"+window.location.host+"/worksdetail?id="+id+"&plate="+belongSection


            if(this.isLogin){
                window.open(url, '_blank');
            }else{
                window.open(url2, '_blank');
            }
        },
        getFriendStatus(){
            let _this=this;
            let url="/rrbi/friends/getFriendStatus?userId="+_this.production.creatorId+"&currentUserId="+_this.loginUserId+"&ti="+new Date().getMilliseconds();
            _this.$axios.get(url).then(function(result){
                _this.friendStatus = result.data
            })
        },
        addFriend() {
            let _this = this;
            if (_this.global.isLogin) {
                let url = '/rrbi/friends/add/' + _this.production.creatorId + "?ti=" + new Date().getMilliseconds();
                _this.$axios.get(url).then(function (result) {
                    console.log(result)
                    if (result.data.response.code == 1) {
                        _this.$message.success(result.data.response.msg)
                        _this.friendStatus = 1
                    } else {
                        _this.$message.error(result.data.response.msg)
                    }
                })
            }
        },
    }
}
</script>

<style scoped lang="less">
  .pagintion-f {
    padding: 20px 0 40px;
    text-align: center;
  }
.works-detail {
  padding-top: @NAVHEIGHT;
  .demand-play {
    .container {
      object {
        embed {
          width: 100% !important;
          height: 100vh !important;
        }
      }
      /deep/.ccH5playerBox {
        margin: 5px auto;
      }
      /deep/.ccH5playerBox.ccH5PlayerBoxFixed {
        margin: 0 !important;
        padding: 0 !important;
        width: 100% !important;
        height: 100% !important;
      }
    }
    /deep/.ccH5Poster {
      img {
        width: 100%;
        height: 100%;
      }
    }
    .no-success-add {
      overflow: hidden;
      position: relative;
      margin: 5px auto;
      .img-fm {
        width: 100%;
      }
      .no-play-icon {
        position: absolute;
        left: 50%;
        top: 50%;
        margin: -20px 0 0 -20px;
        width: 40px;
        height: 40px;
        background-image: url(../../assets/images/video_play_icon.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }
  .about-works {
    padding: 10px;
    line-height: 30px;
    color: #808080;
    font-size: 16px;
    background: #f6f6f6;
  }
}
@media screen and (max-width: 750px) {
  .works-detail {
    .demand-play {
      .container {
        /deep/.ccH5playerBox {
          width: 100% !important;
          height: 250px !important;
        }
      }
      .no-success-add {
        width: 100%;
        // height: 250px;
      }
    }
  }
}
@media screen and (min-width: 751px) {
  .works-detail {
    .demand-play {
      .container {
        /deep/.ccH5playerBox {
          width: 300px !important;
          height: 208px !important;
        }
      }
      .no-success-add {
        width: 300px;
        // height: 208px;
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .works-detail {
    .demand-play {
      .container {
        /deep/.ccH5playerBox {
          width: 600px !important;
          height: 416px !important;
        }
      }
      .no-success-add {
        width: 600px;
        // height: 416px;
      }
    }
  }
}
@media screen and (min-width: 1250px) {
  .works-detail {
    .demand-play {
      .container {
        /deep/.ccH5playerBox {
          width: 640px !important;
          height: 540px !important;
        }
      }
      .no-success-add {
        width: 640px;
        // height: 540px;
      }
    }
  }
}
@media screen and (min-width: 1366px) {
  .works-detail {
    .demand-play {
      .container {
        /deep/.ccH5playerBox {
          width: 750px !important;
          height: 520px !important;
        }
      }
      .no-success-add {
        width: 750px;
        // height: 520px;
      }
    }
  }
}
//@import "../../assets/less/stylePublic.less";
</style>
